import { configureStore } from "@reduxjs/toolkit";

// aboutus
import aboutus from "./aboutus";
import homepage from "./homepage";
import parentalcounselling from "./parentalcounselling";
import blogs from "./blogs";
import careercounselling from "./careercounselling";
import auth from "./auth";
import contain from "./contain";
import profile from "./profile";
import test from "./test";
import get_exam_questions from "./get_exam_questions";
import app_setup from "./app_setup";

export const store = configureStore({
  reducer: {
    aboutus,
    blogs,
    parentalcounselling,
    homepage,
    careercounselling,
    auth,
    contain,
    profile,
    test,
    get_exam_questions,
    app_setup,
  },
});
